import { render, staticRenderFns } from "./FinishedJoinRequestDataTable.vue?vue&type=template&id=4f041ea4"
import script from "./FinishedJoinRequestDataTable.vue?vue&type=script&lang=js"
export * from "./FinishedJoinRequestDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports